import { Bell, Clock3, TrendingUp } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { auditorDashboardData } from "../../data/auditorDashboard";
import { cn } from "@/shared/lib/cn";

const rows = [
  { key: "auditedToday", icon: TrendingUp, iconClassName: "text-accent" },
  { key: "avgAuditTime", icon: Clock3, iconClassName: "text-primary" },
  { key: "pendingOver48h", icon: Bell, iconClassName: "text-accent-foreground" },
] as const;

export function AuditorProductivityIndicators() {
  const { t } = useTranslation();
  const labels = t.safecheck.dashboard.auditorBoard.productivity;
  const { productivity } = auditorDashboardData;

  return (
    <div className="theme-card p-5">
      <h3 className="mb-5 text-sm font-semibold text-foreground">{labels.title}</h3>
      <div className="space-y-4">
        {rows.map((row) => {
          const Icon = row.icon;
          const value = productivity[row.key];

          return (
            <div
              key={row.key}
              className="flex items-center justify-between gap-4 border-b border-border pb-4 last:border-b-0 last:pb-0"
            >
              <span className="flex items-center gap-3 text-sm text-muted-foreground">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-card-muted">
                  <Icon size={16} className={cn(row.iconClassName)} />
                </span>
                {labels[row.key]}
              </span>
              <span className="text-sm font-semibold text-foreground">{value}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
